import React, { Component } from 'react';
import { Text, View } from 'react-native';

import SelectionList from '../components/selection_list';

import { getUIReminderValues } from './event_UI_helpers';
import { OPComponent, Navigation, Utils, NavBar } from '../components';
import { styles } from '../../constants/styles';

export default class SelectReminder extends OPComponent {
  constructor(props) {
    super(props);

    this.state = {
      items: getUIReminderValues(),
    };
  }

  navigationButtonPressed = ({ buttonId }) => {
    if (NavBar.handleButtonPress2(buttonId, this)) return;
  };

  componentDidMount() {
    Utils.trackScreen('Calendar', 'Location');
    Navigation.registerForButtonEvents(this);

    if (this.props.asModal) {
      Navigation.setButtons(
        {
          leftButtons: [NavBar.buttons.done],
        },
        this.props.componentId
      );
    }
  }
  componentWillUnmount() {
    Navigation.unRegisterForButtonEvents(this);
  }

  handleSelect = (selectedId) => {
    this.props.onSelect && this.props.onSelect(selectedId);
  };

  render() {
    return (
      <View style={styles.containerAlt}>
        <SelectionList
          items={this.state.items}
          selectedId={this.props.selectedId}
          onSelect={this.handleSelect}
        />
      </View>
    );
  }
}
